module.exports = __webpack_public_path__ + "media/images/iconSearch__inactive--dark-fc1b4e0f41e152af9b176ef4903e3d7e.png";